<template>
  <section class="storm-band">
    <div class="storm-text">
      <p class="kicker">Wind, hail or a fallen tree?</p>
      <h2>Storm Damage &amp; Insurance Claim Help</h2>
      <p>
        We inspect your roof for free, document the damage with photos for your insurance claim,
        and make lasting repairs. See what to do in the first 24 hours after a storm.
      </p>
    </div>
    <div class="storm-actions">
      <router-link to="/storm-damage-repair" class="storm-link">What to do after a storm</router-link>
      <template v-if="bothOffices">
        <a href="tel:+12692625055" class="storm-call">Niles: (269) 262-5055</a>
        <a href="tel:+19898583559" class="storm-call">Gaylord: (989) 858-3559</a>
      </template>
      <a v-else :href="'tel:' + phoneHref" class="storm-call">Call {{ phone }}</a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StormHelpBand',
  props: {
    phone: { type: String, default: '(269) 262-5055' },
    phoneHref: { type: String, default: '+12692625055' },
    // Pages that serve both locations show both office numbers
    bothOffices: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.storm-band {
  max-width: 1080px;
  margin: 30px auto;
  padding: 28px 30px;
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  gap: 24px;
  align-items: center;
  text-align: left;
  background: linear-gradient(135deg, rgba(141, 8, 8, 0.85) 0%, rgba(90, 10, 20, 0.85) 100%);
  border: 2px solid rgba(241, 196, 15, 0.7);
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
}

.kicker {
  margin: 0 0 6px;
  color: #f1c40f;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}

h2 {
  margin: 0 0 10px;
  color: #fff;
  font-size: clamp(1.3rem, 1.6vw + 0.8rem, 1.8rem);
}

.storm-text p:last-child {
  margin: 0;
  color: #f3e6e6;
  line-height: 1.65;
}

.storm-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.storm-link,
.storm-call {
  display: block;
  text-align: center;
  padding: 14px 20px;
  border-radius: 8px;
  font-weight: bold;
  text-decoration: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.storm-link {
  background: #f1c40f;
  color: #1a1a1a;
}

.storm-link:hover {
  background: #ffd83d;
  transform: translateY(-2px);
}

.storm-call {
  border: 2px solid #fff;
  color: #fff;
}

.storm-call:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

@media (max-width: 760px) {
  .storm-band {
    grid-template-columns: 1fr;
    margin: 24px 16px;
    padding: 22px 18px;
  }
}
</style>
